import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import InputMask from "react-input-mask";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  Stack,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import DirectionsCarOutlinedIcon from "@mui/icons-material/DirectionsCarOutlined";
import AttachmentOutlinedIcon from "@mui/icons-material/AttachmentOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import { Input, Select } from "antd";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { storage } from "../../config/firebase";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import {
  cardIconSx,
  newClientThemeVars,
} from "../../theme/globalStyle/globalStyle";
import theme from "../../theme";
import vehicleService from "../../service/vehicle.service";
import {
  focusFirstInvalidField,
  isReboqueStarted,
  isVehicleTypeRequiringReboque,
  validateVehicleForm,
} from "./validation";
import "./vehicle.css";
import { useSelector } from "react-redux";

const STATES_UF = [
  { value: "AC", label: "Acre" },
  { value: "AL", label: "Alagoas" },
  { value: "AP", label: "Amapá" },
  { value: "AM", label: "Amazonas" },
  { value: "BA", label: "Bahia" },
  { value: "CE", label: "Ceará" },
  { value: "DF", label: "Distrito Federal" },
  { value: "ES", label: "Espírito Santo" },
  { value: "GO", label: "Goiás" },
  { value: "MA", label: "Maranhão" },
  { value: "MT", label: "Mato Grosso" },
  { value: "MS", label: "Mato Grosso do Sul" },
  { value: "MG", label: "Minas Gerais" },
  { value: "PA", label: "Pará" },
  { value: "PB", label: "Paraíba" },
  { value: "PR", label: "Paraná" },
  { value: "PE", label: "Pernambuco" },
  { value: "PI", label: "Piauí" },
  { value: "RJ", label: "Rio de Janeiro" },
  { value: "RN", label: "Rio Grande do Norte" },
  { value: "RS", label: "Rio Grande do Sul" },
  { value: "RO", label: "Rondônia" },
  { value: "RR", label: "Roraima" },
  { value: "SC", label: "Santa Catarina" },
  { value: "SP", label: "São Paulo" },
  { value: "SE", label: "Sergipe" },
  { value: "TO", label: "Tocantins" },
];

const VEHICLE_TYPES = [
  "FIORINO",
  "TRUCK",
  "BI-TRUCK",
  "CARRETA S",
  "CARRETA LS",
  "TOCO",
  "3/4",
  "VUC",
  "BITREM",
  "RODOTREM",
  "MUNK",
  "VANDERLEIA",
];

const BODYWORK_TYPES = [
  "BOBINEIRA",
  "GRADE BAIXA",
  "BAÚSECO",
  "BAÚ FRIGORIFICO",
  "ABERTO",
  "BAÚ",
  "DOLLY",
  "GRANELEIRO",
  "SIDER",
  "PRANCHA",
  "TANQUE",
  "CAÇAMBA",
  "PORTA CONTEINER",
  "CILO",
  "CEGONHA",
];

const DIALOG_TITLE_ID = "vehicle-alert-dialog-title";
const DIALOG_DESCRIPTION_ID = "vehicle-alert-dialog-description";

function parseDialogMessageItems(msg) {
  if (Array.isArray(msg)) {
    return msg.map((item) => String(item || "").trim()).filter(Boolean);
  }

  if (msg == null || msg === "") return [];

  return String(msg)
    .split(/\r?\n/)
    .map((line) => line.replace(/^[-•*]\s*/, "").trim())
    .filter((line) => {
      if (!line) return false;
      const normalized = line.toLowerCase();
      return (
        !normalized.includes("seguinte") &&
        !normalized.includes("obrigatório(s) estão vazio")
      );
    });
}

function isRequiredFieldsDialog(title) {
  return String(title || "")
    .toLowerCase()
    .includes("obrigat");
}

const emptyReboque = () => ({
  id: "",
  placaReboque: "",
  renavamReboque: "",
  ufReboque: "",
  descricaoReboque: "",
  rntrcReboque: "",
  tipoRNTRCReboque: "",
  TipoCarroceriaReboque: "",
  anttReboque: "",
  cnhReboque: "",
  capacidadeKGReboque: "",
  capacidadeM3Reboque: "",
  pesoTaraReboque: "",
  tipoProprietarioReboque: "cpf",
  cpfoucnpjReboque: "",
  nomeProprietarioReboque: "",
});

function NewVehicle() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const user = useSelector((state) => state.user);

  const canView =
    user?.permissoes?.vehicle?.isView ||
    user?.permissoes?.veiculo?.visualizar;
  const canCreate =
    user?.permissoes?.vehicle?.isCreate ||
    user?.permissoes?.veiculo?.cadastrar;
  const canEdit =
    user?.permissoes?.vehicle?.isEdit ||
    user?.permissoes?.veiculo?.editar;

  const view =
    Boolean(location.state?.viewOnly) ||
    Boolean(id && !canEdit) ||
    false;

  const [vehiclePlate, setVehiclePlate] = useState("");
  const [renavam, setRenavam] = useState("");
  const [ufVeiculo, setUfVeiculo] = useState("");
  const [documentCRLV, setDocumentCRLV] = useState("");
  const [descricaoVeiculo, setDescricaoVeiculo] = useState("");
  const [vehicleType, setVehicleType] = useState("");
  const [rntrc, setRntrc] = useState("");
  const [tipoRNTRC, setTipoRNTRC] = useState("");
  const [bodyworkType, setBodyworkType] = useState("");
  const [bodyworkPlate, setBodyworkPlate] = useState("");
  const [documentAnttFrontImg, setDocumentAnttFrontImg] = useState("");
  const [pesoTara, setPesoTara] = useState("");
  const [capacidadeKG, setCapacidadeKG] = useState("");
  const [capacidadeM3, setCapacidadeM3] = useState("");
  const [tipoProprietario, setTipoProprietario] = useState("cpf");
  const [cpfoucnpj, setCpfoucnpj] = useState("");
  const [nomeProprietario, setNomeProprietario] = useState("");
  const [vehicleImg, setVehicleImg] = useState("");
  const [reboques, setReboques] = useState([]);

  const [carregando, setCarregando] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const [title, setTitle] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false);

  useEffect(() => {
    if (!user?.permissoes) return;

    if (!id && !canCreate) {
      navigate("/vehicleList", { replace: true });
      return;
    }

    if (id && !canView && !canEdit) {
      navigate("/vehicleList", { replace: true });
    }
  }, [id, user?.permissoes, canCreate, canView, canEdit, navigate]);

  useEffect(() => {
    if (!id) return;

    const load = async () => {
      setCarregando(true);
      try {
        const response = await vehicleService.getById(id);
        const data = response?.data?.data;
        if (!data) return;

        setVehiclePlate(data.vehiclePlate || "");
        setRenavam(data.renavam || "");
        setUfVeiculo(data.ufVeiculo || "");
        setDocumentCRLV(data.documentCRLV || "");
        setDescricaoVeiculo(data.descricaoVeiculo || "");
        setVehicleType(data.vehicleType || "");
        setRntrc(data.rntrc || "");
        setTipoRNTRC(data.tipoRNTRC || "");
        setBodyworkType(data.bodyworkType || "");
        setBodyworkPlate(data.bodyworkPlate || "");
        setDocumentAnttFrontImg(data.documentAnttFrontImg || "");
        setPesoTara(data.pesoTara || "");
        setCapacidadeKG(data.capacidadeKG || "");
        setCapacidadeM3(data.capacidadeM3 || "");
        setTipoProprietario(data.tipoProprietario || "cpf");
        setCpfoucnpj(data.cpfoucnpj || "");
        setNomeProprietario(data.nomeProprietario || "");
        setVehicleImg(data.vehicleImg || "");
        setReboques(
          Array.isArray(data.reboques)
            ? data.reboques.map((r) => ({ ...emptyReboque(), ...r }))
            : [],
        );
      } catch (error) {
        showDialog(
          "Erro",
          error?.response?.data?.message || "Não foi possível carregar o veículo.",
        );
      } finally {
        setCarregando(false);
      }
    };

    load();
  }, [id]);

  const getFormData = () => ({
    vehiclePlate,
    renavam,
    ufVeiculo,
    documentCRLV,
    descricaoVeiculo,
    vehicleType,
    rntrc,
    tipoRNTRC,
    bodyworkType,
    bodyworkPlate,
    documentAnttFrontImg,
    pesoTara,
    capacidadeKG,
    capacidadeM3,
    tipoProprietario,
    cpfoucnpj,
    nomeProprietario,
    vehicleImg,
    reboques,
  });

  useEffect(() => {
    if (!hasAttemptedSubmit) return;

    const result = validateVehicleForm(getFormData());
    setFieldErrors(result.success ? {} : result.fieldErrors);
  }, [
    hasAttemptedSubmit,
    vehiclePlate,
    renavam,
    ufVeiculo,
    documentCRLV,
    descricaoVeiculo,
    vehicleType,
    rntrc,
    tipoRNTRC,
    bodyworkType,
    bodyworkPlate,
    documentAnttFrontImg,
    pesoTara,
    capacidadeKG,
    capacidadeM3,
    tipoProprietario,
    cpfoucnpj,
    nomeProprietario,
    vehicleImg,
    reboques,
  ]);

  const showDialog = (dialogTitle, dialogMsg) => {
    setTitle(dialogTitle);
    setMsg(dialogMsg);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleUpload = (file, onReady) => {
    if (!file) return;
    setUploading(true);
    const storageId = id || "new";
    const storageRef = ref(storage, `vehicle/${storageId}/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      () => {},
      (error) => {
        console.error(error);
        setUploading(false);
        showDialog("Erro", "Falha no upload do documento.");
      },
      async () => {
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
        onReady(downloadURL);
        setUploading(false);
      },
    );
  };

  const updateReboqueField = (index, field, value) => {
    setReboques((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [field]: value };
      return next;
    });
  };

  const addReboque = () => {
    setReboques((prev) => [...prev, emptyReboque()]);
  };

  const removeReboque = (index) => {
    setReboques((prev) => prev.filter((_, i) => i !== index));
  };

  const requiresReboque = isVehicleTypeRequiringReboque(vehicleType);
  const capacityFieldsDisabled = requiresReboque || view;

  const handleVehicleTypeChange = (value) => {
    setVehicleType(value);
    if (isVehicleTypeRequiringReboque(value)) {
      setPesoTara("");
      setCapacidadeKG("");
      setCapacidadeM3("");
      setBodyworkType("");
      setBodyworkPlate("");
    }
  };

  const getFieldError = (path) => fieldErrors[path] || "";

  const buildPayload = () => ({
    uidShipper: user.uidShipper || "",
    vehiclePlate,
    renavam: renavam || "",
    ufVeiculo: ufVeiculo || "",
    documentCRLV: documentCRLV || "",
    descricaoVeiculo: descricaoVeiculo || "",
    vehicleType: vehicleType || "",
    rntrc: rntrc || "",
    tipoRNTRC: tipoRNTRC || "",
    bodyworkType: bodyworkType || "",
    bodyworkPlate: bodyworkPlate || "",
    documentAnttFrontImg: documentAnttFrontImg || "",
    pesoTara: pesoTara || "",
    capacidadeKG: capacidadeKG || "",
    capacidadeM3: capacidadeM3 || "",
    tipoProprietario: tipoProprietario || "",
    cpfoucnpj: cpfoucnpj || "",
    nomeProprietario: nomeProprietario || "",
    vehicleImg: vehicleImg || "",
    reboques: reboques.filter(isReboqueStarted).map((r) => ({
      ...(r.id ? { id: r.id } : {}),
      placaReboque: r.placaReboque,
      renavamReboque: r.renavamReboque || "",
      ufReboque: r.ufReboque || "",
      descricaoReboque: r.descricaoReboque || "",
      rntrcReboque: r.rntrcReboque || "",
      tipoRNTRCReboque: r.tipoRNTRCReboque || "",
      TipoCarroceriaReboque: r.TipoCarroceriaReboque || "",
      anttReboque: r.anttReboque || "",
      cnhReboque: r.cnhReboque || "",
      capacidadeKGReboque: r.capacidadeKGReboque || "",
      capacidadeM3Reboque: r.capacidadeM3Reboque || "",
      pesoTaraReboque: r.pesoTaraReboque || "",
      tipoProprietarioReboque: r.tipoProprietarioReboque || "",
      cpfoucnpjReboque: r.cpfoucnpjReboque || "",
      nomeProprietarioReboque: r.nomeProprietarioReboque || "",
    })),
  });

  const save = async () => {
    if (view) return;
    if (id && !canEdit) {
      showDialog("Sem permissão", "Você não tem permissão para editar veículos.");
      return;
    }
    if (!id && !canCreate) {
      showDialog("Sem permissão", "Você não tem permissão para cadastrar veículos.");
      return;
    }

    setHasAttemptedSubmit(true);
    const validation = validateVehicleForm(getFormData());
    if (!validation.success) {
      setFieldErrors(validation.fieldErrors);
      showDialog("Campos obrigatórios faltando", validation.messages);
      window.setTimeout(() => {
        focusFirstInvalidField(validation.firstFieldPath);
      }, 0);
      return;
    }

    setFieldErrors({});
    setCarregando(true);
    try {
      const payload = buildPayload();
      if (id) {
        await vehicleService.update(id, payload);
      } else {
        await vehicleService.create(payload);
      }
      navigate("/vehicleList");
    } catch (error) {
      const apiErrors = error?.response?.data?.errors;
      const message =
        error?.response?.data?.message ||
        (Array.isArray(apiErrors) && apiErrors[0]?.message) ||
        "Não foi possível salvar o veículo.";
      showDialog("Erro", message);
    } finally {
      setCarregando(false);
    }
  };

  const pageTitle = view
    ? "Visualização de veículo"
    : id
      ? "Editar veículo"
      : "Cadastro de veículo";
  const pageSubtitle = view
    ? "Consulte os dados do veículo e reboques vinculados."
    : "Organize os dados do veículo, documentos e reboques em um único cadastro.";

  const dialogMessageItems = parseDialogMessageItems(msg);
  const requiredFieldsDialog = isRequiredFieldsDialog(title);
  const showErrorList =
    requiredFieldsDialog ||
    (Array.isArray(msg) && dialogMessageItems.length > 0);
  const dialogDescription = requiredFieldsDialog
    ? "Os seguintes campos obrigatórios estão vazios:"
    : null;
  const dialogBodyText = !showErrorList ? String(msg || "") : "";
  const DialogAlertIcon = requiredFieldsDialog
    ? WarningAmberRoundedIcon
    : ErrorOutlineRoundedIcon;

  return (
    <NewMiniDrawer
      divOpen={
        <Box
          className="new-vehicle-page"
          sx={pageWrapperSx}
          style={newClientThemeVars}
        >
          <Card sx={heroCardSx}>
            <CardContent sx={{ p: { xs: 2, md: 3 } }}>
              <Box className="new-vehicle-hero">
                <Stack spacing={1}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Box sx={cardIconSx}>
                      <LocalShippingOutlinedIcon sx={{ color: "#ffffff" }} />
                    </Box>
                    <Typography sx={heroTitleSx}>{pageTitle}</Typography>
                  </Box>
                  <Typography sx={heroSubtitleSx}>{pageSubtitle}</Typography>
                </Stack>
                {view ? (
                  <Box sx={statusPillSx}>Somente leitura</Box>
                ) : (
                  <Box sx={statusPillSx}>
                    {id ? "Atualização" : "Novo registro"}
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>

          <Box className="new-vehicle-form">
            <SectionCard
              icon={<DirectionsCarOutlinedIcon sx={{ color: "#ffffff" }} />}
              title="Dados do veículo"
              subtitle="Informações principais já utilizadas no cadastro de motorista."
            >
              <Box className="new-vehicle-grid">
                <Field
                  label="Placa do veículo *"
                  span={3}
                  fieldPath="vehiclePlate"
                  error={getFieldError("vehiclePlate")}
                >
                  <InputMask
                    disabled={view}
                    mask="aaa-9*99"
                    maskChar=""
                    className="form-control"
                    value={vehiclePlate}
                    onChange={(e) =>
                      setVehiclePlate(e.target.value.toUpperCase())
                    }
                  >
                    {(inputProps) => (
                      <input
                        {...inputProps}
                        aria-invalid={Boolean(getFieldError("vehiclePlate"))}
                        aria-describedby={
                          getFieldError("vehiclePlate")
                            ? "vehicle-field-vehiclePlate-error"
                            : undefined
                        }
                      />
                    )}
                  </InputMask>
                </Field>

                <Field
                  label="Renavam *"
                  span={3}
                  fieldPath="renavam"
                  error={getFieldError("renavam")}
                >
                  <Input
                    disabled={view}
                    maxLength={11}
                    status={getFieldError("renavam") ? "error" : undefined}
                    value={renavam}
                    onChange={(e) =>
                      setRenavam(e.target.value.replace(/\D/g, ""))
                    }
                    aria-invalid={Boolean(getFieldError("renavam"))}
                    aria-describedby={
                      getFieldError("renavam")
                        ? "vehicle-field-renavam-error"
                        : undefined
                    }
                  />
                </Field>

                <Field
                  label="UF Veículo *"
                  span={2}
                  fieldPath="ufVeiculo"
                  error={getFieldError("ufVeiculo")}
                >
                  <Select
                    disabled={view}
                    style={{ width: "100%" }}
                    status={getFieldError("ufVeiculo") ? "error" : undefined}
                    value={ufVeiculo || undefined}
                    placeholder="Selecione"
                    onChange={setUfVeiculo}
                    options={STATES_UF.map((s) => ({
                      value: s.value,
                      label: `${s.label} (${s.value})`,
                    }))}
                    allowClear
                    aria-invalid={Boolean(getFieldError("ufVeiculo"))}
                    aria-describedby={
                      getFieldError("ufVeiculo")
                        ? "vehicle-field-ufVeiculo-error"
                        : undefined
                    }
                  />
                </Field>

                <Field
                  label="Tipo de veículo *"
                  span={4}
                  fieldPath="vehicleType"
                  error={getFieldError("vehicleType")}
                >
                  <Select
                    disabled={view}
                    style={{ width: "100%" }}
                    status={getFieldError("vehicleType") ? "error" : undefined}
                    value={vehicleType || undefined}
                    placeholder="Selecione"
                    onChange={handleVehicleTypeChange}
                    options={VEHICLE_TYPES.map((t) => ({
                      value: t,
                      label: t,
                    }))}
                    allowClear
                    aria-invalid={Boolean(getFieldError("vehicleType"))}
                    aria-describedby={
                      getFieldError("vehicleType")
                        ? "vehicle-field-vehicleType-error"
                        : undefined
                    }
                  />
                </Field>

                <Field label="Descrição Veículo" span={6}>
                  <Input
                    disabled={view}
                    maxLength={200}
                    value={descricaoVeiculo}
                    onChange={(e) => setDescricaoVeiculo(e.target.value)}
                  />
                </Field>

                <Field
                  label="RNTRC *"
                  span={2}
                  fieldPath="rntrc"
                  error={getFieldError("rntrc")}
                >
                  <Input
                    disabled={view}
                    maxLength={8}
                    status={getFieldError("rntrc") ? "error" : undefined}
                    value={rntrc}
                    onChange={(e) =>
                      setRntrc(e.target.value.replace(/\D/g, ""))
                    }
                    aria-invalid={Boolean(getFieldError("rntrc"))}
                    aria-describedby={
                      getFieldError("rntrc")
                        ? "vehicle-field-rntrc-error"
                        : undefined
                    }
                  />
                </Field>

                <Field
                  label="Tipo RNTRC *"
                  span={2}
                  fieldPath="tipoRNTRC"
                  error={getFieldError("tipoRNTRC")}
                >
                  <Select
                    disabled={view}
                    style={{ width: "100%" }}
                    status={getFieldError("tipoRNTRC") ? "error" : undefined}
                    value={tipoRNTRC || undefined}
                    placeholder="Selecione"
                    onChange={setTipoRNTRC}
                    options={[
                      { value: "tac", label: "TAC" },
                      { value: "etc", label: "ETC" },
                      { value: "ctc", label: "CTC" },
                    ]}
                    allowClear
                    aria-invalid={Boolean(getFieldError("tipoRNTRC"))}
                    aria-describedby={
                      getFieldError("tipoRNTRC")
                        ? "vehicle-field-tipoRNTRC-error"
                        : undefined
                    }
                  />
                </Field>

                <Field
                  label={requiresReboque ? "Tipo Carroceria" : "Tipo Carroceria *"}
                  span={3}
                  fieldPath="bodyworkType"
                  error={getFieldError("bodyworkType")}
                >
                  <Select
                    disabled={capacityFieldsDisabled}
                    style={{ width: "100%" }}
                    status={getFieldError("bodyworkType") ? "error" : undefined}
                    value={bodyworkType || undefined}
                    placeholder="Selecione"
                    onChange={setBodyworkType}
                    options={BODYWORK_TYPES.map((t) => ({
                      value: t,
                      label: t,
                    }))}
                    allowClear
                    aria-invalid={Boolean(getFieldError("bodyworkType"))}
                    aria-describedby={
                      getFieldError("bodyworkType")
                        ? "vehicle-field-bodyworkType-error"
                        : undefined
                    }
                  />
                </Field>

                <Field label="Placa carroceria" span={3}>
                  <Input
                    disabled={capacityFieldsDisabled}
                    value={bodyworkPlate}
                    onChange={(e) =>
                      setBodyworkPlate(e.target.value.toUpperCase())
                    }
                  />
                </Field>

                <Field label="Peso (Tara)" span={2}>
                  <Input
                    disabled={capacityFieldsDisabled}
                    value={pesoTara}
                    onChange={(e) => setPesoTara(e.target.value)}
                  />
                </Field>

                <Field label="Capacidade (KG)" span={2}>
                  <Input
                    disabled={capacityFieldsDisabled}
                    value={capacidadeKG}
                    onChange={(e) => setCapacidadeKG(e.target.value)}
                  />
                </Field>

                <Field label="Capacidade (M³)" span={2}>
                  <Input
                    disabled={capacityFieldsDisabled}
                    value={capacidadeM3}
                    onChange={(e) => setCapacidadeM3(e.target.value)}
                  />
                </Field>

                <Field label="Tipo Proprietário" span={2}>
                  <Select
                    disabled={view}
                    style={{ width: "100%" }}
                    value={tipoProprietario || undefined}
                    onChange={setTipoProprietario}
                    options={[
                      { value: "cpf", label: "CPF" },
                      { value: "cnpj", label: "CNPJ" },
                    ]}
                  />
                </Field>

                <Field
                  label={
                    tipoProprietario === "cnpj"
                      ? "CNPJ Proprietário"
                      : "CPF Proprietário"
                  }
                  span={4}
                >
                  <InputMask
                    disabled={view}
                    mask={
                      tipoProprietario === "cnpj"
                        ? "99.999.999/9999-99"
                        : "999.999.999-99"
                    }
                    maskChar=""
                    className="form-control"
                    value={cpfoucnpj}
                    onChange={(e) => setCpfoucnpj(e.target.value)}
                  >
                    {(inputProps) => <input {...inputProps} />}
                  </InputMask>
                </Field>

                <Field label="Nome Proprietário" span={6}>
                  <Input
                    disabled={view}
                    value={nomeProprietario}
                    onChange={(e) => setNomeProprietario(e.target.value)}
                  />
                </Field>
              </Box>
            </SectionCard>

            <SectionCard
              icon={<AttachmentOutlinedIcon sx={{ color: "#ffffff" }} />}
              title="Documentos"
              subtitle="CRLV e Doc ANTT seguem o mesmo padrão do cadastro de motorista (URL no Storage)."
            >
              <Box className="new-vehicle-grid">
                <Field
                  label="CRLV *"
                  span={6}
                  fieldPath="documentCRLV"
                  error={getFieldError("documentCRLV")}
                >
                  <DocumentField
                    url={documentCRLV}
                    disabled={view || uploading}
                    error={Boolean(getFieldError("documentCRLV"))}
                    errorId="vehicle-field-documentCRLV-error"
                    onUpload={(file) =>
                      handleUpload(file, setDocumentCRLV)
                    }
                    onClear={() => setDocumentCRLV("")}
                  />
                </Field>
                <Field
                  label="Doc ANTT *"
                  span={6}
                  fieldPath="documentAnttFrontImg"
                  error={getFieldError("documentAnttFrontImg")}
                >
                  <DocumentField
                    url={documentAnttFrontImg}
                    disabled={view || uploading}
                    error={Boolean(getFieldError("documentAnttFrontImg"))}
                    errorId="vehicle-field-documentAnttFrontImg-error"
                    onUpload={(file) =>
                      handleUpload(file, setDocumentAnttFrontImg)
                    }
                    onClear={() => setDocumentAnttFrontImg("")}
                  />
                </Field>
                <Field label="Imagem do veículo" span={6}>
                  <DocumentField
                    url={vehicleImg}
                    disabled={view || uploading}
                    onUpload={(file) => handleUpload(file, setVehicleImg)}
                    onClear={() => setVehicleImg("")}
                  />
                </Field>
              </Box>
            </SectionCard>

            <SectionCard
              icon={<LocalShippingOutlinedIcon sx={{ color: "#ffffff" }} />}
              title="Reboques"
              subtitle={
                requiresReboque
                  ? "Este tipo de veículo exige o cadastro de pelo menos 1 reboque completo."
                  : "Cadastre nenhum, um ou vários reboques vinculados a este veículo."
              }
            >
              {getFieldError("reboques") ? (
                <Typography
                  id="vehicle-field-reboques-error"
                  role="alert"
                  className="new-vehicle-field-error"
                  sx={{ mb: 1.5 }}
                  data-field-path="reboques"
                >
                  {getFieldError("reboques")}
                </Typography>
              ) : null}

              {!view && (
                <Box sx={{ mb: 2 }}>
                  <Button
                    variant="outlined"
                    startIcon={<AddIcon />}
                    onClick={addReboque}
                    sx={secondaryActionSx}
                  >
                    Adicionar reboque
                  </Button>
                </Box>
              )}

              {reboques.length === 0 ? (
                <Typography sx={{ color: "rgba(1,36,67,0.62)", fontSize: 14 }}>
                  Nenhum reboque vinculado.
                </Typography>
              ) : (
                reboques.map((reboque, index) => {
                  const placaPath = `reboques.${index}.placaReboque`;
                  const renavamPath = `reboques.${index}.renavamReboque`;
                  const ufPath = `reboques.${index}.ufReboque`;
                  const rntrcPath = `reboques.${index}.rntrcReboque`;
                  const tipoRntrcPath = `reboques.${index}.tipoRNTRCReboque`;
                  const carroceriaPath = `reboques.${index}.TipoCarroceriaReboque`;
                  const anttPath = `reboques.${index}.anttReboque`;

                  return (
                  <Box key={reboque.id || index} className="reboque-block">
                    <Box className="reboque-block-header">
                      <Typography sx={sectionTitleSx}>
                        Reboque #{index + 1}
                      </Typography>
                      {!view && (
                        <Button
                          color="error"
                          startIcon={<DeleteIcon />}
                          onClick={() => removeReboque(index)}
                        >
                          Remover
                        </Button>
                      )}
                    </Box>

                    <Box className="new-vehicle-grid">
                      <Field
                        label="Placa Reboque *"
                        span={3}
                        fieldPath={placaPath}
                        error={getFieldError(placaPath)}
                      >
                        <InputMask
                          disabled={view}
                          mask="aaa-9*99"
                          maskChar=""
                          className="form-control"
                          value={reboque.placaReboque}
                          onChange={(e) =>
                            updateReboqueField(
                              index,
                              "placaReboque",
                              e.target.value.toUpperCase(),
                            )
                          }
                        >
                          {(inputProps) => (
                            <input
                              {...inputProps}
                              aria-invalid={Boolean(getFieldError(placaPath))}
                              aria-describedby={
                                getFieldError(placaPath)
                                  ? `vehicle-field-${placaPath.replace(/\./g, "-")}-error`
                                  : undefined
                              }
                            />
                          )}
                        </InputMask>
                      </Field>

                      <Field
                        label="Renavam Reboque *"
                        span={3}
                        fieldPath={renavamPath}
                        error={getFieldError(renavamPath)}
                      >
                        <Input
                          disabled={view}
                          maxLength={11}
                          status={getFieldError(renavamPath) ? "error" : undefined}
                          value={reboque.renavamReboque}
                          onChange={(e) =>
                            updateReboqueField(
                              index,
                              "renavamReboque",
                              e.target.value.replace(/\D/g, ""),
                            )
                          }
                          aria-invalid={Boolean(getFieldError(renavamPath))}
                          aria-describedby={
                            getFieldError(renavamPath)
                              ? `vehicle-field-${renavamPath.replace(/\./g, "-")}-error`
                              : undefined
                          }
                        />
                      </Field>

                      <Field
                        label="UF Reboque *"
                        span={2}
                        fieldPath={ufPath}
                        error={getFieldError(ufPath)}
                      >
                        <Select
                          disabled={view}
                          style={{ width: "100%" }}
                          status={getFieldError(ufPath) ? "error" : undefined}
                          value={reboque.ufReboque || undefined}
                          placeholder="Selecione"
                          onChange={(v) =>
                            updateReboqueField(index, "ufReboque", v)
                          }
                          options={STATES_UF.map((s) => ({
                            value: s.value,
                            label: s.value,
                          }))}
                          allowClear
                          aria-invalid={Boolean(getFieldError(ufPath))}
                          aria-describedby={
                            getFieldError(ufPath)
                              ? `vehicle-field-${ufPath.replace(/\./g, "-")}-error`
                              : undefined
                          }
                        />
                      </Field>

                      <Field label="Descrição Reboque" span={4}>
                        <Input
                          disabled={view}
                          value={reboque.descricaoReboque}
                          onChange={(e) =>
                            updateReboqueField(
                              index,
                              "descricaoReboque",
                              e.target.value,
                            )
                          }
                        />
                      </Field>

                      <Field
                        label="RNTRC Reboque *"
                        span={2}
                        fieldPath={rntrcPath}
                        error={getFieldError(rntrcPath)}
                      >
                        <Input
                          disabled={view}
                          maxLength={8}
                          status={getFieldError(rntrcPath) ? "error" : undefined}
                          value={reboque.rntrcReboque}
                          onChange={(e) =>
                            updateReboqueField(
                              index,
                              "rntrcReboque",
                              e.target.value.replace(/\D/g, ""),
                            )
                          }
                          aria-invalid={Boolean(getFieldError(rntrcPath))}
                          aria-describedby={
                            getFieldError(rntrcPath)
                              ? `vehicle-field-${rntrcPath.replace(/\./g, "-")}-error`
                              : undefined
                          }
                        />
                      </Field>

                      <Field
                        label="Tipo RNTRC Reboque *"
                        span={2}
                        fieldPath={tipoRntrcPath}
                        error={getFieldError(tipoRntrcPath)}
                      >
                        <Select
                          disabled={view}
                          style={{ width: "100%" }}
                          status={
                            getFieldError(tipoRntrcPath) ? "error" : undefined
                          }
                          value={reboque.tipoRNTRCReboque || undefined}
                          placeholder="Selecione"
                          onChange={(v) =>
                            updateReboqueField(index, "tipoRNTRCReboque", v)
                          }
                          options={[
                            { value: "tac", label: "TAC" },
                            { value: "etc", label: "ETC" },
                            { value: "ctc", label: "CTC" },
                          ]}
                          allowClear
                          aria-invalid={Boolean(getFieldError(tipoRntrcPath))}
                          aria-describedby={
                            getFieldError(tipoRntrcPath)
                              ? `vehicle-field-${tipoRntrcPath.replace(/\./g, "-")}-error`
                              : undefined
                          }
                        />
                      </Field>

                      <Field
                        label="Tipo Carroceria Reboque *"
                        span={3}
                        fieldPath={carroceriaPath}
                        error={getFieldError(carroceriaPath)}
                      >
                        <Select
                          disabled={view}
                          style={{ width: "100%" }}
                          status={
                            getFieldError(carroceriaPath) ? "error" : undefined
                          }
                          value={reboque.TipoCarroceriaReboque || undefined}
                          placeholder="Selecione"
                          onChange={(v) =>
                            updateReboqueField(
                              index,
                              "TipoCarroceriaReboque",
                              v,
                            )
                          }
                          options={BODYWORK_TYPES.map((t) => ({
                            value: t,
                            label: t,
                          }))}
                          allowClear
                          aria-invalid={Boolean(getFieldError(carroceriaPath))}
                          aria-describedby={
                            getFieldError(carroceriaPath)
                              ? `vehicle-field-${carroceriaPath.replace(/\./g, "-")}-error`
                              : undefined
                          }
                        />
                      </Field>

                      <Field label="Tipo Proprietário Reboque" span={3}>
                        <Select
                          disabled={view}
                          style={{ width: "100%" }}
                          value={
                            reboque.tipoProprietarioReboque || undefined
                          }
                          onChange={(v) =>
                            updateReboqueField(
                              index,
                              "tipoProprietarioReboque",
                              v,
                            )
                          }
                          options={[
                            { value: "cpf", label: "CPF" },
                            { value: "cnpj", label: "CNPJ" },
                          ]}
                        />
                      </Field>

                      <Field label="CPF/CNPJ Proprietário Reboque" span={4}>
                        <Input
                          disabled={view}
                          value={reboque.cpfoucnpjReboque}
                          onChange={(e) =>
                            updateReboqueField(
                              index,
                              "cpfoucnpjReboque",
                              e.target.value,
                            )
                          }
                        />
                      </Field>

                      <Field label="Nome Proprietário Reboque" span={4}>
                        <Input
                          disabled={view}
                          value={reboque.nomeProprietarioReboque}
                          onChange={(e) =>
                            updateReboqueField(
                              index,
                              "nomeProprietarioReboque",
                              e.target.value,
                            )
                          }
                        />
                      </Field>

                      <Field
                        label="ANTT Reboque *"
                        span={6}
                        fieldPath={anttPath}
                        error={getFieldError(anttPath)}
                      >
                        <DocumentField
                          url={reboque.anttReboque}
                          disabled={view || uploading}
                          error={Boolean(getFieldError(anttPath))}
                          errorId={`vehicle-field-${anttPath.replace(/\./g, "-")}-error`}
                          onUpload={(file) =>
                            handleUpload(file, (url) =>
                              updateReboqueField(index, "anttReboque", url),
                            )
                          }
                          onClear={() =>
                            updateReboqueField(index, "anttReboque", "")
                          }
                        />
                      </Field>
                    </Box>
                  </Box>
                  );
                })
              )}
            </SectionCard>

            <Card sx={actionsCardSx}>
              <CardContent sx={{ p: { xs: 2, md: 2.4 } }}>
                <Box className="new-vehicle-actions">
                  <Button
                    component={Link}
                    to="/vehicleList"
                    variant="outlined"
                    startIcon={<ArrowBackOutlinedIcon />}
                    sx={secondaryActionSx}
                  >
                    Voltar
                  </Button>
                  <Button
                    disabled={view || carregando || uploading}
                    variant="contained"
                    startIcon={
                      carregando ? (
                        <CircularProgress color="inherit" size={16} />
                      ) : (
                        <SaveOutlinedIcon />
                      )
                    }
                    onClick={save}
                    sx={primaryActionSx}
                  >
                    {carregando ? "Salvando..." : "Salvar"}
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Box>

          <Dialog
            open={open}
            onClose={handleClose}
            role="dialog"
            aria-modal="true"
            aria-labelledby={DIALOG_TITLE_ID}
            aria-describedby={DIALOG_DESCRIPTION_ID}
            fullWidth
            maxWidth="sm"
            scroll="paper"
            BackdropProps={{
              sx: dialogBackdropSx,
            }}
            PaperProps={{
              sx: dialogPaperSx,
            }}
          >
            <Box sx={dialogHeaderSx}>
              <Box sx={dialogIconWrapSx}>
                <DialogAlertIcon
                  sx={{
                    fontSize: 26,
                    color: theme.colors.highlight,
                  }}
                />
              </Box>
              <Box sx={{ minWidth: 0, flex: 1 }}>
                <Typography
                  id={DIALOG_TITLE_ID}
                  component="h2"
                  sx={dialogTitleSx}
                >
                  {title || "Atenção"}
                </Typography>
                {dialogDescription ? (
                  <Typography
                    id={DIALOG_DESCRIPTION_ID}
                    sx={dialogSubtitleSx}
                  >
                    {dialogDescription}
                  </Typography>
                ) : null}
              </Box>
            </Box>

            <DialogContent
              id={dialogDescription ? undefined : DIALOG_DESCRIPTION_ID}
              sx={dialogContentSx}
            >
              {showErrorList ? (
                <Box
                  component="ul"
                  sx={dialogErrorListSx}
                  aria-label="Lista de campos obrigatórios"
                >
                  {dialogMessageItems.map((item, index) => (
                    <Box
                      component="li"
                      key={`${item}-${index}`}
                      sx={dialogErrorItemSx}
                    >
                      <Box component="span" sx={dialogErrorBulletSx} />
                      <Typography component="span" sx={dialogErrorTextSx}>
                        {item}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              ) : (
                <Typography sx={dialogBodyTextSx}>{dialogBodyText}</Typography>
              )}
            </DialogContent>

            <Divider sx={{ borderColor: theme.colors.primaryBorder }} />

            <DialogActions sx={dialogActionsSx}>
              <Button
                onClick={handleClose}
                variant="contained"
                autoFocus
                disableElevation
                sx={dialogPrimaryButtonSx}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      }
    />
  );
}

function DocumentField({ url, disabled, onUpload, onClear, error, errorId }) {
  return (
    <Box className={error ? "new-vehicle-document-field has-error" : "new-vehicle-document-field"}>
      {url ? (
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <a href={url} target="_blank" rel="noreferrer">
            Ver documento
          </a>
          {!disabled && (
            <Button size="small" color="error" onClick={onClear}>
              Remover
            </Button>
          )}
        </Box>
      ) : (
        <input
          type="file"
          disabled={disabled}
          aria-invalid={error ? "true" : undefined}
          aria-describedby={error ? errorId : undefined}
          onChange={(e) => onUpload(e.target.files?.[0])}
        />
      )}
    </Box>
  );
}

function SectionCard({ icon, title, subtitle, children }) {
  return (
    <Card sx={sectionCardSx}>
      <CardContent sx={{ p: { xs: 2, md: 2.4 } }}>
        <Box className="new-vehicle-section-heading">
          <Box sx={cardIconSx}>{icon}</Box>
          <Box>
            <Typography sx={sectionTitleSx}>{title}</Typography>
            <Typography sx={sectionSubtitleSx}>{subtitle}</Typography>
          </Box>
        </Box>
        <Divider sx={{ mb: 2, borderColor: "rgba(1, 36, 67, 0.10)" }} />
        {children}
      </CardContent>
    </Card>
  );
}

function Field({ label, span = 3, error, fieldPath, children }) {
  const errorId = fieldPath
    ? `vehicle-field-${String(fieldPath).replace(/\./g, "-")}-error`
    : undefined;

  return (
    <div
      className={`new-vehicle-field new-vehicle-span-${span}${error ? " has-error" : ""}`}
      data-field-path={fieldPath || undefined}
    >
      <label>{label}</label>
      {children}
      {error ? (
        <span id={errorId} className="new-vehicle-field-error" role="alert">
          {error}
        </span>
      ) : null}
    </div>
  );
}

export default NewVehicle;

const pageWrapperSx = {
  p: { xs: 2, md: 3 },
  display: "flex",
  flexDirection: "column",
  gap: 2,
};

const heroCardSx = {
  borderRadius: "18px",
  border: "1px solid var(--new-client-primary-border)",
  boxShadow: "var(--new-client-shadow-soft)",
};

const sectionCardSx = {
  borderRadius: "var(--new-client-radius-lg)",
  border: "1px solid var(--new-client-primary-border)",
  boxShadow: "var(--new-client-shadow-section)",
  background: "var(--new-client-surface-soft)",
};

const actionsCardSx = {
  borderRadius: "var(--new-client-radius-lg)",
  border: "1px solid var(--new-client-primary-border)",
  boxShadow: "var(--new-client-shadow-section)",
};

const heroTitleSx = {
  color: "var(--new-client-primary)",
  fontWeight: 700,
  fontSize: "1.25rem",
};

const heroSubtitleSx = {
  color: "rgba(1, 36, 67, 0.74)",
  fontSize: "0.92rem",
  lineHeight: 1.5,
  maxWidth: 760,
};

const sectionTitleSx = {
  color: "var(--new-client-primary)",
  fontWeight: 700,
  fontSize: "1.05rem",
};

const sectionSubtitleSx = {
  color: "rgba(1, 36, 67, 0.62)",
  fontSize: "0.79rem",
  lineHeight: 1.45,
};

const statusPillSx = {
  border: "1px solid var(--new-client-primary-border)",
  borderRadius: "999px",
  color: "var(--new-client-primary)",
  background: "var(--new-client-primary-soft)",
  px: 1.5,
  py: 0.5,
  fontSize: "0.78rem",
  fontWeight: 600,
  whiteSpace: "nowrap",
};

const primaryActionSx = {
  textTransform: "none",
  fontWeight: theme.typography.weightSemibold,
  borderRadius: `${theme.radius.medium - 2}px`,
  backgroundColor: "var(--new-client-primary)",
  minHeight: 40,
  px: 2,
  "&:hover": {
    backgroundColor: "var(--new-client-primary-hover)",
  },
};

const secondaryActionSx = {
  textTransform: "none",
  fontWeight: theme.typography.weightSemibold,
  borderRadius: `${theme.radius.medium - 2}px`,
  minHeight: 40,
  color: "var(--new-client-primary)",
  borderColor: "var(--new-client-primary-border)",
};

const dialogBackdropSx = {
  backgroundColor: "rgba(1, 36, 66, 0.48)",
  backdropFilter: "blur(4px)",
  WebkitBackdropFilter: "blur(4px)",
};

const dialogPaperSx = {
  borderRadius: `${theme.radius.large}px`,
  backgroundColor: theme.colors.surface,
  boxShadow: "0 18px 40px rgba(1, 36, 66, 0.18)",
  overflow: "hidden",
  width: "100%",
  maxWidth: 520,
  mx: { xs: 2, sm: 3 },
  my: { xs: 2, sm: 3 },
  maxHeight: "min(88vh, 640px)",
  display: "flex",
  flexDirection: "column",
  transition: theme.motion.transition,
};

const dialogHeaderSx = {
  display: "flex",
  alignItems: "flex-start",
  gap: `${theme.spacing.sm}px`,
  px: { xs: 2, sm: 2.5 },
  pt: { xs: 2, sm: 2.5 },
  pb: { xs: 1.5, sm: 2 },
  backgroundColor: theme.colors.highlightSoft,
  borderBottom: `1px solid ${theme.colors.primaryBorder}`,
};

const dialogIconWrapSx = {
  width: 44,
  height: 44,
  borderRadius: "50%",
  backgroundColor: theme.colors.surface,
  border: `1px solid ${theme.colors.primaryBorder}`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  boxShadow: "0 4px 12px rgba(1, 36, 66, 0.08)",
};

const dialogTitleSx = {
  color: theme.colors.primary,
  fontFamily: theme.typography.fontFamily,
  fontWeight: theme.typography.weightBold,
  fontSize: { xs: "1.05rem", sm: "1.2rem" },
  lineHeight: 1.3,
  letterSpacing: theme.typography.letterSpacing,
};

const dialogSubtitleSx = {
  mt: 0.5,
  color: theme.colors.textSecondary,
  fontFamily: theme.typography.fontFamily,
  fontWeight: theme.typography.weightRegular,
  fontSize: theme.typography.bodySize,
  lineHeight: theme.typography.bodyLineHeight,
};

const dialogContentSx = {
  px: { xs: 2, sm: 2.5 },
  py: { xs: 1.75, sm: 2 },
  overflowY: "auto",
  maxHeight: { xs: "42vh", sm: "46vh" },
};

const dialogErrorListSx = {
  listStyle: "none",
  m: 0,
  p: 0,
  display: "flex",
  flexDirection: "column",
  gap: `${theme.spacing.xs}px`,
};

const dialogErrorItemSx = {
  display: "flex",
  alignItems: "flex-start",
  gap: `${theme.spacing.xs}px`,
  px: 1.25,
  py: 1,
  borderRadius: `${theme.radius.small}px`,
  backgroundColor: theme.colors.highlightSoft,
  border: `1px solid ${theme.colors.primaryBorder}`,
};

const dialogErrorBulletSx = {
  width: 7,
  height: 7,
  borderRadius: "50%",
  backgroundColor: theme.colors.highlight,
  flexShrink: 0,
  mt: "0.45rem",
};

const dialogErrorTextSx = {
  color: theme.colors.textPrimary,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.bodySize,
  lineHeight: 1.45,
  fontWeight: theme.typography.weightSemibold,
  wordBreak: "break-word",
};

const dialogBodyTextSx = {
  color: theme.colors.textSecondary,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.bodySize,
  lineHeight: 1.5,
  whiteSpace: "pre-line",
  wordBreak: "break-word",
};

const dialogActionsSx = {
  px: { xs: 2, sm: 2.5 },
  py: { xs: 1.5, sm: 2 },
  justifyContent: { xs: "stretch", sm: "flex-end" },
  gap: 1,
};

const dialogPrimaryButtonSx = {
  textTransform: "none",
  fontFamily: theme.typography.fontFamily,
  fontWeight: theme.typography.weightSemibold,
  borderRadius: `${theme.radius.medium - 2}px`,
  backgroundColor: theme.colors.primary,
  color: theme.colors.white,
  border: `1px solid ${theme.colors.primary}`,
  minHeight: 42,
  minWidth: { xs: "100%", sm: 112 },
  px: 2.5,
  transition: theme.motion.transition,
  "&:hover": {
    backgroundColor: theme.colors.white,
    color: theme.colors.primary,
    borderColor: theme.colors.primary,
  },
  "&:active": {
    backgroundColor: theme.colors.white,
    color: theme.colors.primary,
    borderColor: theme.colors.primary,
    opacity: 0.92,
  },
  "&.Mui-focusVisible": {
    outline: `2px solid ${theme.colors.highlight}`,
    outlineOffset: 2,
  },
  "&.Mui-disabled": {
    backgroundColor: theme.colors.switchTrackDisabled,
    color: theme.colors.textSecondary,
    borderColor: theme.colors.switchTrackDisabled,
  },
};
